module.exports = __webpack_public_path__ + "static/video-poster-a592e5936cc5b52c50f40481bbc651fc.png";